/* eslint-disable import/prefer-default-export */
export const QUERY_KEYS = {
  dashboard: {
    earnings: "earnings",
    eventCards: "eventCards",
  },
  patient: {
    creatableCareEvents: "creatableCareEvents",
  },
  patients: "patientList",
  unreadMessagesCount: "unreadMessagesCount",
  conversations: "conversations",
};
